/** 提现 */
<template>
	<div class="withdrawal-list-wrap">
		<BasiceLayout :title="$t('buyBackTitle') " class="withdrawal-layout" empty-text="loading">
			
		</BasiceLayout>
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import BasiceLayout from '@/components/Common/BasicLayout.vue'

export default {
  name: 'AccountLayout',
  components: {
    BasiceLayout
  },
  props: {},
  computed: mapState({
    //  箭头函数可使代码更简练
    buyBackList: state => state.buyBack.buyBackList,
  }),
  methods: {
    ...mapActions(['getBuyBackList'])
  },
  created() {
    this.getBuyBackList()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="stylus">

</style>

<i18n>
{
	"en": {
    "buyBackTitle": "USDT充值码",
    "addressNotYet": "暂未生成",
    "addressCommited": "已提交，等待生成新的充值码。",
    "addressGen": "USDT充值码已生成。"
	},
	"zn": {
    "buyBackTitle": "USDT充值码",
    "addressNotYet": "暂未生成",
    "addressCommited": "已提交，等待生成新的充值码。",
    "addressGen": "USDT充值码已生成。"
	}
}
</i18n>
